export default "__VITE_ASSET__5c476bdd__"